import React from 'react';
import { BookmarkPlus, BookmarkCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface SaveToTBRButtonProps {
  isSaved: boolean;
  onToggle: () => void;
  loading?: boolean;
  size?: 'sm' | 'default';
  variant?: 'ghost' | 'outline';
}

export function SaveToTBRButton({ 
  isSaved, 
  onToggle, 
  loading = false,
  size = 'sm',
  variant = 'ghost'
}: SaveToTBRButtonProps) {
  return (
    <Button
      variant={variant}
      size={size}
      onClick={onToggle}
      disabled={loading}
      className={cn(
        "flex items-center gap-1 transition-colors",
        isSaved 
          ? "text-green-600 hover:text-green-700" 
          : "text-muted-foreground hover:text-foreground"
      )}
    >
      {isSaved ? (
        <BookmarkCheck className="w-4 h-4" />
      ) : (
        <BookmarkPlus className="w-4 h-4" />
      )}
      <span className="text-sm font-medium">
        {isSaved ? 'Saved' : 'Save to TBR'}
      </span>
    </Button>
  );
}